<template>
  <div>
    <a-tabs defaultActiveKey="1">
      <a-tab-pane tab="CALENDARIO DE NÓMINA" key="1">
        <a-row>
          <g-master name="calendario_nomina"
                    @params="paramsTable"
                    :endpoint="master.endpoint"
                    :tableSetup="master.tableSetup"
                    :modalFieldsSetup="master.modalFieldsSetup"
                    ref="master"
                    modalWidth="80%"
          >
            <template slot="customButton">
              <g-btn-excel :endpoint="endpointExcel" :params="paramsExcel" :fileName="fileNameExcel"/>
            </template>
            <span slot="estadoRenderer" slot-scope="{text}">
              <div v-if="text ==='INACTIVO'">
                <a-tag color="red">{{text}}</a-tag>
              </div>
              <div v-if="text ==='ACTIVO'">
                <a-tag color="blue">{{text}}</a-tag>
              </div>
            </span>
            <template slot="masterModal" slot-scope="{record}">
              <a-row :gutter="[16,16]">
                <a-col v-bind="colOptions">
                  <g-dropdown :label="$t('Compañía')"
                              :formItemConfig="fiOptions"
                              endpoint="company"
                              :decorator="['company', { rules: [{ required: false, message: 'Valor requerido' }]}]">
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Año')" v-bind="fiOptions">
                    <a-select v-decorator="['year', { rules: [
                            { required: false}], initialValue: yearToday },
                           ]" style="width: 100%">
                      <a-select-option v-for="year_ in years" :key="year_">
                        {{ year_ }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>

                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Mes')" v-bind="fiOptions">
                    <a-select v-decorator="['month', { rules: [
                            { required: false},
                           ] }]" style="width: 100%">
                      <a-select-option v-for="month_ in months_name" :key="month_.value">
                        {{ month_.name }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>

                <a-col v-bind="colOptions">
                  <g-dropdown :label="$t('Periodo')"
                              :formItemConfig="fiOptions"
                              endpoint="hierarchy_lookup"
                              :decorator="['period', { rules: [{ required: false, message: 'Valor requerido'}] }]"
                              :params="period_request">
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Dtini')" v-bind="fiOptions">
                    <a-date-picker style="width: 100%"
                                   type="date"
                                   valueFormat="Y-MM-DD HH:mm:ss"
                                   v-decorator="['dtini', { rules: [{ required: false, message: 'Valor requerido' }] }]"></a-date-picker>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Dtend')" v-bind="fiOptions">
                    <a-date-picker style="width: 100%"
                                   type="date"
                                   valueFormat="Y-MM-DD HH:mm:ss"
                                   v-decorator="['dtend', { rules: [{ required: false, message: 'Valor requerido' }] }]"></a-date-picker>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Dtfrq')" v-bind="fiOptions">
                    <a-date-picker style="width: 100%"
                                   type="date"
                                   valueFormat="Y-MM-DD HH:mm:ss"
                                   v-decorator="['dtfrq', { rules: [{ required: false, message: 'Valor requerido' }] }]"></a-date-picker>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Dtpay')" v-bind="fiOptions">
                    <a-date-picker style="width: 100%"
                                   type="date"
                                   valueFormat="Y-MM-DD HH:mm:ss"
                                   v-decorator="['dtpay', { rules: [{ required: false, message: 'Valor requerido' }] }]"></a-date-picker>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown :label="$t('Tipo de pago')"
                              :formItemConfig="fiOptions"
                              endpoint="hierarchy_lookup"
                              :decorator="['tpay', { rules: [{ required: false, message: 'Valor requerido'}] }]"
                              :params="tpay"
                  >
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown v-bind="fiOptions"
                              endpoint="hierarchy_lookup"
                              :label="$t('Estado')"
                              :formItemConfig="fiOptions"
                              :decorator="['period_status', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                              :params="estado">
                  </g-dropdown>
                </a-col>
              </a-row>
            </template>
          </g-master>
        </a-row>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        tpay: {
          h_lookup_type: 'TIPO PAGO',
          use_code: true
        },
        estado: {
          h_lookup_type: 'ESTADO_ACT_INA',
          use_code: true
        },
        period_request: {h_lookup_type: 'PERIODOS_LIQUIDACION', use_code: true},
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        months_name: [
          {name: 'Enero', value: '1'},
          {name: 'Febrero', value: '2'},
          {name: 'Marzo', value: '3'},
          {name: 'Abril', value: '4'},
          {name: 'Mayo', value: '5'},
          {name: 'Junio', value: '6'},
          {name: 'Julio', value: '7'},
          {name: 'Agosto', value: '8'},
          {name: 'Septiembre', value: '9'},
          {name: 'Octubre', value: '10'},
          {name: 'Noviembre', value: '11'},
          {name: 'Diciembre', value: '12'}
        ],
        yearToday: parseInt(moment().format('YYYY')),
        years: [],
        loadingBtns: {},
        colOptions: {xs: 24, sm: 12},
        master: {
          endpoint: 'payroll_calendar',
          tableSetup: {
            customSlots: ['estadoRenderer'],
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Compañía', dataIndex: 'nombre_compania', sorter: true},
              {title: 'Año', dataIndex: 'year', sorter: true},
              {title: 'Mes', dataIndex: 'mes', sorter: true},
              {title: 'ID Periodo', dataIndex: 'period', sorter: true},
              {title: 'Período', dataIndex: 'periodo', sorter: true},
              {title: 'Dtini', dataIndex: 'dtini_desc', sorter: true},
              {title: 'Dtend', dataIndex: 'dtend_desc', sorter: true},
              {title: 'Dtfrq', dataIndex: 'dtfrq_desc', sorter: true},
              {title: 'Tipo de pago', dataIndex: 'tipo_pago', sorter: true},
              {title: 'Dtpay', dataIndex: 'dtpay_desc', sorter: true},
              {
                title: 'Estado',
                dataIndex: 'estado',
                sorter: true,
                scopedSlots: {
                  customRender: 'estadoRenderer'
                }
              },
              {title: 'Creado por', dataIndex: 'created_by', sorter: true},
              {title: 'Creado el', dataIndex: 'created_on', sorter: true},
              {title: 'Modificado por', dataIndex: 'modified_by', sorter: true},
              {title: 'Modificado el', dataIndex: 'modified_on', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'company'},
            {name: 'period'},
            {name: 'year'},
            {name: 'month'},
            {name: 'dtend'},
            {name: 'dtini'},
            {name: 'dtfrq'},
            {name: 'dtpay'},
            {name: 'tpay'},
            {name: 'period_status'}
          ]
        },
        endpointExcel: 'payroll_calendar_/downloadExcel',
        fileNameExcel: 'CalendarioDeNomina',
        paramsT: {}
      }
    },
    mounted () {
      this.yearsSelect()
    },
    methods: {
      yearsSelect () {
        for (let i = this.yearToday - 30; i <= (this.yearToday + 30); i++) {
          this.years.push(i)
        }
      },
      paramsTable (params) {
        this.paramsT = params
      }
    },
    computed: {
      paramsExcel () {
        return {...this.paramsT, columns: this.master.tableSetup.columns}
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/CalendarioNomina/CalendarioNomina.vue